import { qs } from '../utils/domHelpers.js';

export class ReadMore {
  constructor(baseQueryEl) {
    this.baseQueryEl = baseQueryEl;
  }

  init() {
    const readMoreEl = qs('.readmore', this.baseQueryEl);
    const content = qs('.readmore-content', this.baseQueryEl);
    if (readMoreEl && content) {
      // Add ARIA attributes to the button to indicate control of expandable content
      readMoreEl.setAttribute('aria-expanded', 'false');
      if (!content.id) {
        content.id = 'readmore-content';
      }
      readMoreEl.setAttribute('aria-controls', content.id);

      // Add aria-live attribute so that screen readers announce changes to the content
      content.setAttribute('aria-live', 'polite');

      readMoreEl.addEventListener('click', (e) => {
        e.preventDefault();
        // Toggle the content visibility without removing the button
        const isActive = content.classList.toggle('readmore-content--active');
        // Update the aria-expanded attribute based on the state of the content
        readMoreEl.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });
    }
  }
}